import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Divider } from '@/components';

interface Props {
  setFile?: (file: File | null) => void;
  file?: File | null;
  src?: string | null;
  accept?: { [p: string]: [] };
  multiple?: boolean;
  maxSize?: number;
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
}

// TODO make info text from params
// TODO check size
// TODO check file types especially show the file/s
export default function ImageUploader({
  setFile = () => null,
  file,
  src,
  accept = {
    'image/jpeg': [],
    'image/png': [],
  },
  multiple = false,
  maxSize = 2 * 1024 * 1024,
}: Props) {
  const [buffer, setBuffer] = useState<string | ArrayBuffer | null>(null);
  const [error, setError] = useState<string | null>();

  useEffect(() => {
    if (src) setBuffer(null);
  }, [src]);

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    accept,
    multiple,
    onDrop: ([acceptedFile]) => {
      // setError(null);
      const reader = new FileReader();

      reader.onload = function (e) {
        setBuffer(e.target?.result ?? null);
      };

      reader.readAsDataURL(acceptedFile);
      setFile(acceptedFile);

      return buffer;
    },
    maxSize,
    onError: (err) => setError(err.message),
  });

  useEffect(() => {
    return () => URL.revokeObjectURL(buffer as string);
  }, []);

  return (
    <div className='flex flex-col w-full gap-y-4 text-center p-6'>
      {/* <p className='text-base leading-6 font-medium text-slate-600 dark:text-white/80'> */}
      {/*   Attach Documents */}
      {/* </p> */}
      {!file && !buffer && (
        <div
          {...getRootProps()}
          className='drop-zone flex flex-col justify-center items-center gap-y-4 px-32 w-full h-64 border-2 border-dashed border-blue-400 dark:border-[#FFDA68] p-4 rounded-3xl bg-blue-50 dark:bg-[#151515]'
        >
          {src ? (
            <img src={src as string} className='h-24 w-24 self-center' alt='uploaded file' />
          ) : (
            <i className='icon-image-add' />
          )}
          <p className='text-base leading-6 font-medium text-slate-700 dark:text-white'>
            Drag and Drop Here
          </p>
          {/*<span className='text-xs text-slate-400 font-light'>*/}
          {/*  - - - - - - - - - or - - - - - - - - -*/}
          {/*</span>*/}
          <Divider
            borderClassName='h-1 border-dashed border-blue-200 dark:border-white'
            className='w-full text-gray-500 dark:text-white'
          >
            OR
          </Divider>
          <button
            type='button'
            onClick={open}
            className='px-6 py-2 text-sm text-white bg-blue-500 dark:bg-transparent dark:border dark:border-[#FFDA68] dark:text-[#FFDA68] rounded-[10px]'
          >
            Select Photo
          </button>
        </div>
      )}
      {buffer && (
        <div className='flex flex-col gap-y-2 items-center relative'>
          <img src={buffer as string} className='max-w-xs self-center' alt='selected file' />
          <button
            className='btn btn-ok dark:border-[#FFDA68] dark:text-[#FFDA68]'
            type='button'
            onClick={() => {
              URL.revokeObjectURL(buffer as string);
              setFile(null);
              setBuffer(null);
            }}
          >
            Reset
          </button>
        </div>
      )}

      {error && (
        <span className='text-red-400 text-sm'>File does not meet requirements or is invalid.</span>
      )}
      <p className='text-xs leading-5 font-light text-slate-500 dark:text-white'>
        We only accept <strong>jpeg</strong> and <strong>png</strong> files. File size can be a
        maximum of <strong>2mb</strong>. The resolution should be at least <strong>400x400</strong>{' '}
        pixels.
      </p>

      <input {...getInputProps()} className='hidden' />
    </div>
  );
}
